export default __webpack_public_path__ + "static/0155-cd2296b7f3aa176f997963f869d4e869.png";